/* Carlota Mare - barra superior rotativa + barra fija de compra en movil + galeria por color (2026-09-23) + talla obligatoria (2026-10-12)
   + barra fija visible desde la primera pantalla y con la talla elegida (2026-10-13, CRO) */
(() => {
  function initRotators() {
    document.querySelectorAll('[data-cm-rotator]').forEach((row) => {
      if (row.dataset.cmReady) return;
      row.dataset.cmReady = 'true';
      const items = Array.from(row.querySelectorAll('.cm-annc__item'));
      if (items.length < 2) return;
      let i = Math.max(0, items.findIndex((el) => el.classList.contains('is-active')));
      const ms = parseInt(row.dataset.interval, 10) || 4000;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, ms);
    });
  }

  // Si se entra con ?variant= (p. ej. desde Google Shopping), la galeria se abre en la foto de ese color
  function initGalleryStart() {
    const gallery = document.querySelector('main[data-template="product"] media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    const active = viewer.querySelector('[data-media-id].is-active');
    const first = viewer.querySelector('[data-media-id]');
    if (active && active !== first) gallery.setActiveMedia(active.dataset.mediaId, false);
  }

  // Talla obligatoria: la ficha se abre sin talla marcada y no deja anadir/comprar hasta que la clienta la elige
  const SIZE_RE = /talla|size|medida/i;
  let sizeChosen = false;

  function sizeFieldset() {
    const main = document.querySelector('main[data-template="product"]');
    if (!main) return null;
    return (
      Array.from(main.querySelectorAll('variant-selects fieldset')).find((f) => {
        const legend = f.querySelector('legend');
        return legend && SIZE_RE.test(legend.textContent) && f.querySelectorAll('input[type="radio"]').length > 1;
      }) || null
    );
  }

  const sizePending = () => !sizeChosen && !!sizeFieldset();

  function sizeMsg(create) {
    let msg = document.querySelector('.cm-size-msg');
    if (!msg && create) {
      const picker = document.querySelector('main[data-template="product"] variant-selects');
      if (!picker) return null;
      msg = document.createElement('p');
      msg.className = 'cm-size-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Elige tu talla para continuar';
      picker.insertAdjacentElement('afterend', msg);
    }
    return msg;
  }

  function applySizeState() {
    const main = document.querySelector('main[data-template="product"]');
    if (!main) return;
    const fieldset = sizeFieldset();
    const pending = !!fieldset && !sizeChosen;
    if (fieldset && fieldset.classList.contains('cm-size-pending') !== pending) {
      fieldset.classList.toggle('cm-size-pending', pending);
    }
    main.querySelectorAll('product-form').forEach((form) => {
      if (form.classList.contains('cm-needs-size') !== pending) form.classList.toggle('cm-needs-size', pending);
    });
    if (!pending) {
      const msg = sizeMsg(false);
      if (msg && msg.classList.contains('is-visible')) msg.classList.remove('is-visible');
    }
  }

  function askForSize() {
    const msg = sizeMsg(true);
    if (msg) msg.classList.add('is-visible');
    const picker = document.querySelector('main[data-template="product"] variant-selects');
    const target = sizeFieldset() || picker;
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (picker) {
      picker.classList.remove('cm-flash');
      void picker.offsetWidth;
      picker.classList.add('cm-flash');
    }
  }

  function initSizeRequired() {
    const main = document.querySelector('main[data-template="product"]');
    if (!main || !sizeFieldset()) return;

    const style = document.createElement('style');
    style.textContent =
      'main[data-template="product"] .product-form__input--pill.cm-size-pending input[type=radio]:checked+label{background-color:rgb(var(--color-background));color:rgb(var(--color-foreground))}' +
      'main[data-template="product"] product-form.cm-needs-size .product-form__buttons{position:relative}' +
      'main[data-template="product"] product-form.cm-needs-size .product-form__buttons::after{content:"";position:absolute;inset:0;z-index:5;cursor:pointer}' +
      '.cm-size-msg{display:none;margin:.6rem 0 0;font-size:1.4rem;font-weight:700;color:var(--cm-oferta,#A8323E)}' +
      '.cm-size-msg.is-visible{display:block}';
    document.head.appendChild(style);

    const markChosen = (e) => {
      if (sizeChosen) return;
      const fieldset = sizeFieldset();
      const t = e.target;
      if (fieldset && t && t.matches && t.matches('input[type="radio"]') && fieldset.contains(t)) {
        sizeChosen = true;
        applySizeState();
        document.dispatchEvent(new CustomEvent('cm:size-chosen'));
      }
    };
    document.addEventListener('click', markChosen);
    document.addEventListener('change', markChosen);

    const guard = (e) => {
      if (!sizePending()) return;
      const t = e.target;
      if (!t || !t.closest) return;
      const hit =
        e.type === 'submit'
          ? t.closest('main[data-template="product"] product-form')
          : t.closest('main[data-template="product"] product-form .product-form__buttons');
      if (!hit) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      askForSize();
    };
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', guard, true);

    // Al cambiar de color el tema vuelve a pintar el selector: se reaplica el estado
    new MutationObserver(applySizeState).observe(main, { childList: true, subtree: true });
    applySizeState();
  }

  function initStickyAtc() {
    const main = document.querySelector('main[data-template="product"]');
    if (!main || document.querySelector('.cm-sticky-atc')) return;
    const realBtn = main.querySelector('.product-form__submit');
    const priceWrap = main.querySelector('.product__info-container [id^="price-"]');
    if (!realBtn) return;

    const picker = main.querySelector('variant-selects');
    // Lista para comprar si no hay talla que elegir o ya se ha elegido
    const ready = () => !sizePending();

    const bar = document.createElement('div');
    bar.className = 'cm-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="cm-sticky-atc__info"><div class="cm-sticky-atc__price"></div><div class="cm-sticky-atc__size"></div></div>' +
      '<button type="button" class="cm-sticky-atc__btn" tabindex="-1">Añadir al carrito</button>';
    document.body.appendChild(bar);
    const barPrice = bar.querySelector('.cm-sticky-atc__price');
    const barBtn = bar.querySelector('.cm-sticky-atc__btn');
    const barSize = bar.querySelector('.cm-sticky-atc__size');

    const sync = () => {
      if (priceWrap) barPrice.innerHTML = priceWrap.innerHTML;
      const label = realBtn.querySelector('span');
      const text = (label ? label.textContent : realBtn.textContent).trim();
      barBtn.textContent = ready() || realBtn.disabled ? text : 'Elegir talla';
      barBtn.disabled = realBtn.disabled;
      const fs = sizeFieldset();
      const checked = fs && fs.querySelector('input[type="radio"]:checked');
      barSize.textContent = ready() && checked ? 'Talla ' + checked.value : '';
    };
    sync();
    if (priceWrap) new MutationObserver(sync).observe(priceWrap, { childList: true, subtree: true });
    new MutationObserver(sync).observe(realBtn, { attributes: true, childList: true, subtree: true });
    document.addEventListener('change', sync);
    document.addEventListener('cm:size-chosen', sync);

    barBtn.addEventListener('click', () => {
      if (ready() && !realBtn.disabled) {
        realBtn.click();
        return;
      }
      if (sizeFieldset()) {
        askForSize();
        return;
      }
      const target = picker || realBtn;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (picker) {
        picker.classList.remove('cm-flash');
        void picker.offsetWidth;
        picker.classList.add('cm-flash');
      }
    });

    // Visible siempre que el boton real NO este en pantalla: desde la primera pantalla (el boton queda mas abajo)
    // y otra vez al pasarlo. Se esconde mientras el boton real se ve, para no duplicarlo.
    new IntersectionObserver(
      ([entry]) => {
        const past = !entry.isIntersecting;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      },
      { threshold: 0 }
    ).observe(realBtn);
  }

  const start = () => {
    initRotators();
    initGalleryStart();
    initSizeRequired();
    initStickyAtc();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', initRotators);
})();
